import { render } from "./TerminalsDrawer.vue?vue&type=template&id=1fb6291f&scoped=true"
import script from "./TerminalsDrawer.vue?vue&type=script&lang=js"
export * from "./TerminalsDrawer.vue?vue&type=script&lang=js"

import "./TerminalsDrawer.vue?vue&type=style&index=0&id=1fb6291f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb6291f"]])

export default __exports__